export enum PersonType {
    Adult = "adult",
    Child = "child",
}
